import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import CampaignLogModal from './CampaignLogModal';
import type { LogEntry } from '../../state/generalActions';

interface CampaignLogModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for CampaignLogModal (ADR-034).
 * Owns store access and provides data + callbacks to the presenter.
 */
const CampaignLogModalContainer: React.FC<CampaignLogModalContainerProps> = ({ isOpen, onClose }) => {
  const campaignLog: LogEntry[] = useStore(state => state.session?.general?.campaignLog) || [];
  const gameTime = useStore(state => state.session?.general?.gameTime);
  const actions = useActions();

  const handleAddLogEntry = (text: string) => {
    actions.addLogEntry(text);
  };

  return (
    <CampaignLogModal
      isOpen={isOpen}
      onClose={onClose}
      campaignLog={campaignLog}
      gameTime={gameTime ? gameTime.toISOString() : null}
      onAddLogEntry={handleAddLogEntry}
    />
  );
};

export default CampaignLogModalContainer;
